/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export * from './components/bulk-delete-hp.component';
export * from './resources/bulk-delete-hp-business.service';
